import clsx from 'clsx'
import React, { FC } from 'react'

import styles from './ApplePayButton.module.scss'

export interface ApplePayButtonProps{
  className?: string
  onClick?: () => void
}

export const ApplePayButton: FC<ApplePayButtonProps> = ({ className, onClick }) => (
  <button aria-label="Apple Pay" className={clsx(styles.applePayButtonWrapper, className)} onClick={onClick} type="button">
    <div className={clsx(
      styles.applePayButtonWithText,
      styles.applePayButtonBlackWithText,
    )}
    />
  </button>
)
